import { render, staticRenderFns } from "./BlankComponent.vue?vue&type=template&id=b4b858f6&"
import script from "./BlankComponent.vue?vue&type=script&lang=js&"
export * from "./BlankComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports